import "core-js/stable";
import "regenerator-runtime/runtime";
import {call, put} from "redux-saga/effects";
import * as api_types from "./reducer";
import {getDashboardCards} from "./requests";

export function* getDashCardsSaga() {
    try {
        const response = yield call(getDashboardCards);
        if(response.status === 200){
            yield put({type: api_types.GET_DASH_CARDS_SUCCESS, response});
        }else{
            yield put({type: api_types.GET_DASH_CARDS_ERROR, response});
        }
    } catch (error) {
        yield put({type: api_types.GET_DASH_CARDS_ERROR, error})
    }
}

